import React, { useEffect, useState } from "react";
import "./DashboardSkeleton.scss";

function Skel({ className = "", style = {}, animate }) {
  return (
    <div
      className={`DashboardSkeleton-skel ${
        animate ? "DashboardSkeleton-animate" : ""
      } ${className}`}
      style={style}
      aria-hidden="true"
    />
  );
}

export default function DashboardSkeleton() {
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setAnimate(false), 5000); // 5 seconds
    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="DashboardSkeleton-wrapper">
      <div
        className="DashboardSkeleton-root"
        aria-busy="true"
        role="status"
        aria-label="Loading dashboard"
      >
        {/* TOP ROW */}
        <div className="DashboardSkeleton-topRow">
          {/* LEFT HERO */}
          <div className="DashboardSkeleton-leftHero">
            <Skel
              animate={animate}
              className="DashboardSkeleton-heroSquare"
              style={{ width: 280, height: 180, borderRadius: 12 }}
            />

            <div
              className={`DashboardSkeleton-leftLines ${
                animate ? "DashboardSkeleton-animate" : ""
              }`}
            >
              <Skel style={{ height: 14, width: 220, borderRadius: 20 }} />
              <Skel style={{ height: 12, width: 180, borderRadius: 20 }} />
              <Skel style={{ height: 12, width: 150, borderRadius: 20 }} />
              <Skel style={{ height: 12, width: 120, borderRadius: 20 }} />
            </div>
          </div>

          {/* RIGHT HERO */}
          <div className="DashboardSkeleton-rightHero">
            <div className="DashboardSkeleton-bigCard">
              <div className="DashboardSkeleton-bigCardInner">
                <Skel
                  animate={animate}
                  className="DashboardSkeleton-innerRect"
                  style={{ width: 500, height: 200, borderRadius: 12 }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM CARDS */}
        <div className="DashboardSkeleton-cardsRow">
          <div className="DashboardSkeleton-cardsGrid">
            {Array.from({ length: 4 }).map((_, i) => (
              <article key={i} className="DashboardSkeleton-card">
                <div className="DashboardSkeleton-cardHead">
                  <Skel
                    style={{ height: 12, width: 180, borderRadius: 20 }}
                    animate={animate}
                  />
                  <Skel
                    style={{ height: 10, width: 36, borderRadius: 20 }}
                    animate={animate}
                  />
                </div>

                <div className="DashboardSkeleton-cardBody">
                  <div className="DashboardSkeleton-cardMeta">
                    <Skel
                      style={{ height: 38, width: 44, borderRadius: 8 }}
                      animate={animate}
                    />
                    <div className="DashboardSkeleton-metaLines">
                      <Skel
                        style={{ height: 10, width: 120, borderRadius: 20 }}
                        animate={animate}
                      />
                      <Skel
                        style={{
                          height: 10,
                          width: 80,
                          borderRadius: 20,
                          marginTop: 8,
                        }}
                        animate={animate}
                      />
                    </div>
                  </div>

                  <Skel
                    style={{ height: 10, width: "100%", borderRadius: 20 }}
                    animate={animate}
                  />
                </div>

                <div className="DashboardSkeleton-cardFooter">
                  <Skel
                    style={{ height: 10, width: 100, borderRadius: 20 }}
                    animate={animate}
                  />
                  <Skel
                    style={{ height: 10, width: 28, borderRadius: 20 }}
                    animate={animate}
                  />
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
